import { render, staticRenderFns } from "./custom-button.vue?vue&type=template&id=1e16636c&"
import script from "./custom-button.vue?vue&type=script&lang=js&"
export * from "./custom-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports